import type { ComponentProps } from 'react';
import { Table } from '@shigo-ui/ui';
import { cn } from '@shigo-ui/ui/cn';

export function ManagedSelectionTable({
  className,
  containerClassName,
  ...props
}: ComponentProps<typeof Table>) {
  return (
    <Table
      className={cn('min-w-full', className)}
      containerClassName={cn('border-border rounded-md border', containerClassName)}
      {...props}
    />
  );
}
